import { Client } from 'openapi-fetch'

import type { paths } from '@kidzonet/ts-api-generator/clients/dashboard'

import {
    SettingsPatchSchema,
} from './types'

declare global {
    // eslint-disable-next-line vars-on-top
    var DashboardApiClient: Client<paths>
}

export const getSettings = async () => {
    const { data, error } = await globalThis.DashboardApiClient.GET('/v1/public/dashboard/settings')

    if (error) {
        throw error
    }
    const {
        safesearch = false,
        safeyoutube = false,
    } = data
    return {
        safeSearch: safesearch,
        safeYoutube: safeyoutube,
    }
}

const patchSettings = async (body: SettingsPatchSchema) => {
    const { error } = await globalThis.DashboardApiClient.PATCH(
        '/v1/public/dashboard/settings', {
            body,
        },
    )

    if (error) {
        throw error
    }
    return true
}

export const setSettings = async (
    { safeSearch, safeYoutube }: { safeSearch: boolean, safeYoutube: boolean },
) => patchSettings({
    safesearch: safeSearch,
    safeyoutube: safeYoutube,
})

export const setSafeSearch = (value: boolean) => patchSettings({ safesearch: value })
export const setSafeYoutube = (value: boolean) => patchSettings({ safeyoutube: value })
